import { render } from "./Talent.vue?vue&type=template&id=5231cd9f&ts=true"
import script from "./Talent.vue?vue&type=script&lang=ts"
export * from "./Talent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__